module.exports = __webpack_public_path__ + "static/media/moon.97d8008b.svg";